module.exports = __webpack_public_path__ + "img/KGtoggleon.03a4e9cf.png";